import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMail,
  FiMapPin,
  FiPhone,
  FiTwitter,
} from "react-icons/fi";
import logo from "../assets/melona logo.png";

const PremiumFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="premium-footer">
      <div className="premium-footer__content">
        <div className="premium-footer__grid">
          {/* Brand Column */}
          <div className="premium-footer__brand">
            <img src={logo} alt="Melona" style={{ height: "50px", width: "auto", marginBottom: "1rem" }} />
            <p>
              Leading printing, advertising, and digital marketing agency in Debre Birhan, Ethiopia.
              Transforming brands with creative excellence since 2014.
            </p>
            <div className="premium-footer__social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FiFacebook />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FiInstagram />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FiTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FiLinkedin />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="premium-footer__column">
            <h4>Quick Links</h4>
            <ul className="premium-footer__links">
              <li>
                <Link to="/">
                  <FiArrowRight size={14} /> Home
                </Link>
              </li>
              <li>
                <Link to="/about">
                  <FiArrowRight size={14} /> About Us
                </Link>
              </li>
              <li>
                <Link to="/services">
                  <FiArrowRight size={14} /> Services
                </Link>
              </li>
              <li>
                <Link to="/gallery">
                  <FiArrowRight size={14} /> Portfolio
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <FiArrowRight size={14} /> Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="premium-footer__column">
            <h4>Services</h4>
            <ul className="premium-footer__links">
              <li>
                <Link to="/services">
                  <FiArrowRight size={14} /> Digital Marketing
                </Link>
              </li>
              <li>
                <Link to="/services">
                  <FiArrowRight size={14} /> Printing Services
                </Link>
              </li>
              <li>
                <Link to="/services">
                  <FiArrowRight size={14} /> Advertising
                </Link>
              </li>
              <li>
                <Link to="/services">
                  <FiArrowRight size={14} /> Event Management
                </Link>
              </li>
              <li>
                <Link to="/services">
                  <FiArrowRight size={14} /> Brand Design
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="premium-footer__column">
            <h4>Contact Info</h4>
            <ul className="premium-footer__links">
              <li>
                <a href="tel:0956565636">
                  <FiPhone size={14} /> 0956565636
                </a>
              </li>
              <li>
                <a href="tel:0956565646">
                  <FiPhone size={14} /> 0956565646
                </a>
              </li>
              <li>
                <a href="mailto:melona5656@gmail.com">
                  <FiMail size={14} /> melona5656@gmail.com
                </a>
              </li>
              <li>
                <span>
                  <FiMapPin size={14} /> Debre Birhan, Atse Zeryakob Square
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="premium-footer__bottom">
          <p>
            © {currentYear} Melona Printing & Advertising. All rights reserved. Designed with excellence in Debre Birhan, Ethiopia.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PremiumFooter;
